module.exports = __webpack_public_path__ + "img/club_bg.c1aa54d5.png";